import React, { useEffect, useState } from 'react';
import { RootState } from '../../../reducers';
import { bindActionCreators, Dispatch } from 'redux';
import * as actions from '../../../actions';
import * as _actionsSearch from '../../../actions/search';
import * as _actionsProduct from '../../../actions/product';
import * as _actionsFilters from '../../../actions/filters';
import * as _actionsJourney2 from '../../../actions/journey2';
import * as _actionsBasket from '../../../actions/basket';
import { withRouter } from '../../../utils/withRouter';
import { connect, useDispatch } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import classNames from 'classnames';
import Spinner from '../../Spinner';
import { Button, EButtonType } from '@repo/apg-ui';
import { getParameterByName } from '../../../utils/toSearchParams';
import { ReactComponent as RedxIcon } from '../../../assets/icons/redX.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/new/info-dark.svg';
import './Analog.scss';
import { createDateRange, parseToApiDate } from '../../../utils/react';
import { parseISO } from 'date-fns';
import { prepareAddToBasketPayload, prepareUpdateBasketEntryPayload } from '../../../utils/payloads';
import { createBasket, updateBasketEntry } from '../../../utils/basket';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';
import { useNavigate } from 'react-router';
import AnalogConfiguration from './AnalogConfiguration';
import { isEmpty } from 'lodash';
import { clearError } from '../../../actions';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';
import { SchemaNewBasketResponse, SchemaPossibleBookingDates, SchemaProduct } from '@repo/legacy-commerce-api';

interface Props {
  location: any;
  actionsProduct: typeof _actionsProduct;
  userDataEC: PartiallyIntegratedUserDataEC;
  intl: any;
  actionsJourney2: typeof _actionsJourney2;
  possibleBookingDates: SchemaPossibleBookingDates;
  actionsBasket: typeof _actionsBasket;
  errors: any;
  notices: any;
}

const Analog = ({
  location,
  actionsProduct,
  userDataEC,
  intl,
  possibleBookingDates,
  actionsBasket,
  actionsJourney2,
  errors,
  notices,
}: Props) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [invalidDaysInRange, setInvalidDaysInRange] = useState<number[]>([]);
  const [dateRange, setDateRange] = useState([
    createDateRange(new Date(userDataEC.startDate) || new Date(), userDataEC.duration || 7, {
      toEndOfYear: false,
      fullWeeks: true,
    }),
  ]);
  const [duration, setDuration] = useState(userDataEC.duration || 7);
  const [isInBasket, setIsInBasket] = useState(true);

  const { ui, basketProducts } = userDataEC;
  const defaultProduct: SchemaProduct = {
    name: '',
    mediacount: 2,
    productphotopath: '',
    formatcode: '',
    producttype: '',
    additionalinfo: { restriction: { codes: [] } },
    producturn: '',
    address: '',
    availabilities: [],
    mindays: null,
    maxdays: null,
    performancevalue: 0,
    // @ts-expect-error Open API spec mismatch: priceinformation does not exist on type:
    priceinformation: {},
    area: [],
    format: '',
  };

  const [product, setProduct] = useState(defaultProduct);

  const navigate = useNavigate();

  // Scrollt nach oben, wenn Fehler vorhanden sind
  useEffect(() => {
    if (errors && errors.length > 0) {
      window.scrollTo(0, 0);
      if (!isEmpty(errors)) {
        dispatch(clearError(null));
      }
    }
  }, [errors]);

  useEffect(() => {
    const _urn = getParameterByName('urn', location.search);
    const _basketKey = getParameterByName('basketkey', location.search);
    if (_urn) {
      let startRangeDate;
      if (possibleBookingDates) {
        if (possibleBookingDates && possibleBookingDates['start']) {
          startRangeDate = parseISO(possibleBookingDates['start'].date);
        }
      } else {
        if (userDataEC.startDate) {
          startRangeDate = new Date(userDataEC.startDate);
        } else {
          startRangeDate = new Date();
        }
      }

      const basketEntry = basketProducts.productsByUrnDate[_basketKey] ?? null;
      console.log('basketEntry', basketEntry);
      console.log('basketProducts', basketProducts);

      if (userDataEC.startDate > startRangeDate) {
        startRangeDate = new Date(userDataEC.startDate);
      }

      let initialDuration = userDataEC.duration || 7;

      if (basketEntry) {
        setIsInBasket(true);
        startRangeDate = parseISO(basketEntry.startdate);
        setProduct(basketEntry);
        // @ts-expect-error Open API spec mismatch: duration does not exist on type:
        initialDuration = basketEntry.duration;
      } else {
        actionsProduct.fetchProductByUrn({ urn: encodeURI(_urn), date: parseToApiDate(startRangeDate) }).then((res) => {
          res.data.startdate = startRangeDate;
          setIsInBasket(false);
          setProduct(res.data);

          const minDays = res.data?.mindays;
          const maxDays = res.data?.maxdays;
          initialDuration = minDays && initialDuration < minDays ? minDays : initialDuration;
          initialDuration = maxDays && initialDuration > maxDays ? maxDays : initialDuration;
        });
      }

      setDuration(initialDuration);
      const range = createDateRange(startRangeDate, initialDuration, {
        toEndOfYear: false,
        fullWeeks: true,
      });
      setDateRange([range]);
      setIsLoading(false);
    }
  }, [location]);

  const handleDateChange = (range, newDuration) => {
    setDuration(newDuration);
    setDateRange([range]);
  };

  const addToBasket = (basketData) => {
    const { basket, basketreference } = basketData;
    let payload;
    payload = prepareAddToBasketPayload(
      basket,
      basketreference,
      parseToApiDate(dateRange[0].startDate),
      duration,
      product.producturn,
      userDataEC.industry,
    );

    return actionsBasket
      .addToBasket(payload)
      .then((res) => {
        if (res) {
          actionsBasket
            .getBasketContent(basketData)
            .then((res) => {
              setIsLoading(false);
              closeModal();
            })
            .catch((err) => {
              console.error(err);
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
        }
      })
      .catch((res) => {
        setIsLoading(false);
      });
  };

  const doUpdateBasket = (basketData) => {
    const { basket, basketreference } = basketData;
    const _basketKey = getParameterByName('basketkey', location.search);

    const payload = prepareUpdateBasketEntryPayload(
      basket,
      basketreference,
      parseToApiDate(dateRange[0].startDate),
      duration,
    );
    console.log('payload vor updateBasketEntry', payload);
    return updateBasketEntry(
      payload,
      // @ts-expect-error Open API spec mismatch: basketentryid does not exist on type (basketentryId does, capital I):
      userDataEC.basketProducts.productsByUrnDate[_basketKey].basketentryid,
      actionsBasket,
    )
      .then((res) => {
        if (res) {
          actionsBasket
            .getBasketContent(basketData)
            .then((res) => {
              setIsLoading(false);
              closeModal();
            })
            .catch((err) => {
              console.error(err);
              setIsLoading(false);
            });
        } else {
          setIsLoading(false);
        }
      })
      .catch((res) => {
        setIsLoading(false);
      });
  };

  const addOrCreateBasket = () => {
    setIsLoading(true);
    if (userDataEC.basketInfo) {
      if (isInBasket) {
        return doUpdateBasket(userDataEC.basketInfo);
      } else {
        return addToBasket(userDataEC.basketInfo);
      }
    } else {
      return createBasket(userDataEC, dateRange[0].startDate, actionsBasket).then((res: SchemaNewBasketResponse) => {
        return addToBasket({
          basket: res.data.basket,
          basketreference: res.data.basketreference,
        });
      });
    }
  };

  const closeModal = () => {
    setProduct(defaultProduct);
    setIsInBasket(false);
    const redirect = getParameterByName('redirect', location.search);
    if (redirect === 'product') {
      navigate({ search: `?modalContent=product&urn=${product.producturn}` });
    } else {
      navigate({ search: '' });
    }
  };

  return (
    <div
      className={classNames('analogModal', {
        modalLoading: isLoading,
      })}
      id='root'
    >
      {isLoading && <Spinner />}
      <div className={classNames('modalHeader d-flex justify-content-between align-items-start border-bottom h-auto')}>
        <div className='font-24 font-bold'>
          <FormattedMessage id='ec.modals.analog.title' defaultMessage='Anpassen' />
        </div>
        <div className='close-modal align-self-start'>
          <Button onClick={closeModal} className='mt-0'>
            <RedxIcon />
          </Button>
        </div>
      </div>
      <div className={classNames('modalBody h-100')}>
        <div>
          <div className='font-20 font-weight-bold mb-4'>
            <FormattedMessage id='ec.modals.select_date' defaultMessage='Datum wählen' />
          </div>
          {(errors || notices) && (
            <ErrorContainer
              getDataFromRedux={true}
              journeyType={'journey02'}
              classNameErrorWrapper={'mw-100 m-0 mt-3'}
              classNameErrorContainer={'m-0'}
            />
          )}
          <AnalogConfiguration
            intl={intl}
            possibleBookingDates={possibleBookingDates}
            userDataEC={userDataEC}
            actionsJourney2={actionsJourney2}
            handleDateChange={handleDateChange}
            product={product}
            dateRange={dateRange}
            duration={duration}
            setIsLoading={setIsLoading}
            invalidDaysInRange={invalidDaysInRange}
            setInvalidDaysInRange={(flag) => {
              setInvalidDaysInRange(flag);
            }}
          />
        </div>
      </div>
      <div className={classNames('modalFooter border-top d-flex w-100 h-auto bg-white flex-column')}>
        <div
          className={classNames('d-flex align-items-center', {
            'justify-content-end': !ui.isMobile,
            'justify-content-between': ui.isMobile,
          })}
        >
          <Button buttonType={EButtonType.BasicLink} className='mt-0 ' onClick={closeModal}>
            <FormattedMessage id='ec.components.buttons.cancel' defaultMessage='Abbrechen' />
          </Button>
          <Button
            buttonType={EButtonType.InvertedPillMedium}
            className='mt-0 ms-24 text-uppercase'
            isDisabled={isLoading || errors.length > 0 || notices.length > 0 || invalidDaysInRange.length > 0}
            onClick={() => {
              addOrCreateBasket();
            }}
          >
            {isInBasket ? (
              <FormattedMessage id='ec.components.buttons.updateInBasket' defaultMessage='Update' />
            ) : (
              <FormattedMessage id='ec.components.buttons.addToBasket' defaultMessage='Zum Warenkorb hinzufügen' />
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    location: state.router.location,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsSearch: bindActionCreators(_actionsSearch as any, dispatch),
    actionsJourney2: bindActionCreators(_actionsJourney2 as any, dispatch),
    actionsProduct: bindActionCreators(_actionsProduct as any, dispatch),
    actionsFilters: bindActionCreators(_actionsFilters as any, dispatch),
    actionsBasket: bindActionCreators(_actionsBasket as any, dispatch),
    dispatch: dispatch,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Analog)));
